import { render } from "./bestBagCombinationTable.vue?vue&type=template&id=f310d37a&scoped=true&ts=true"
import script from "./bestBagCombinationTable.vue?vue&type=script&lang=ts"
export * from "./bestBagCombinationTable.vue?vue&type=script&lang=ts"

import "./bestBagCombinationTable.vue?vue&type=style&index=0&id=f310d37a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f310d37a"]])

export default __exports__